import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Spinner } from "reactstrap"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { debounce, map, range } from "lodash"
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
//actions
import moment from "moment"
import PropTypes from "prop-types"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min"

import { getStudentVarisangyaWallets } from "store/actions"
//componets
import MyPagination from "components/Common/MyPagination"

//css
import "assets/scss/datatables.scss"

const AllStudentVarisangyaTransactions = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [searchText, setSearchText] = useState("")
  const sort = "manual"
  const [page, setPage] = useState(1)
  const limit = 10

  const { studentVarisangyaWallets, loading, language } = useSelector(
    state => ({
      studentVarisangyaWallets:
        state.StudentVarisangyaWallets.studentVarisangyaWallets,
      loading: state.StudentVarisangyaWallets?.loading,
      language: state.Layout.language,
    })
  )

  const instituteId = location?.search?.split("?instituteId=")[1]

  //pages
  const totalPages = Math.ceil(studentVarisangyaWallets?.count / 10)
  const pages = range(1, totalPages + 1)

  const pageSend = () => {
    if (page >= pages.length) {
      return pages.length
    }
    if (page < 1) {
      return 1
    } else {
      return page
    }
  }

  useEffect(() => {
    dispatch(getStudentVarisangyaWallets(searchText, pageSend(), sort))
  }, [dispatch, page, searchText])

  const columns = [
    {
      dataField: "no",
      text: language === "mal" ? "നo." : "No.",
    },
    {
      dataField: "date",
      text: language === "mal" ? "തീയതി" : "Date",
    },
    {
      dataField: "madrasa_student_name",
      text: language === "mal" ? "വിദ്യാർത്ഥി" : "Student",
    },
    {
      dataField: "amount",
      text: language === "mal" ? "തുക" : "Amount",
    },
    {
      dataField: "balance",
      text: language === "mal" ? "ബാലൻസ്" : "Balance",
    },
    {
      dataField: "remark",
      text: language === "mal" ? "റിമാർക്കുകൾ" : "Remarks",
    },
    {
      dataField: "action",
      text: "",
    },
  ]

  const studentVarisangyaWalletsData = map(
    studentVarisangyaWallets?.results,
    (item, index) => ({
      ...item,
      key: index,
      no: (pageSend() - 1) * limit + index + 1,
      amount: (
        <p
          className={
            item?.trn_type === "credit" ? "text-success" : "text-danger"
          }
        >
          {item?.amount}
        </p>
      ),
      balance: <p className="text-primary">{item?.balance}</p>,
      date: item?.date_added && moment(item?.date_added).format("DD/MM/yyyy"),
      action: (
        <div className="m-0">
          <Link
            to={`/student/varisangya/transaction/print/${item?.id}`}
            className="btn btn-dark w-xs btn-sm"
          >
            <i className="bx bxs-download me-2" />
            {language === "mal" ? "ഡൗൺലോഡ്" : "Print"}
          </Link>
        </div>
      ),
    })
  )

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  // Select All Button operation
  const selectRow = {
    mode: "checkbox",
  }

  const debounceStudentVarisangyaWalletSearch = debounce(
    value => setSearchText(value),
    600
  )

  // const handleSearch = e => {
  //   setSearchText(e.target.value)
  // }

  return (
    <React.Fragment>
      <Row>
        {/* {cardData?.map((item, key) => (
          <Col lg={4} key={key}>
            <Card className="blog-stats-wid">
              <CardBody>
                <Link to={item.routeLink && item.routeLink}>
                  <div className="d-flex flex-wrap">
                    <div className="me-3">
                      <p className="text-muted mb-2">{item.title}</p>
                      {item.cardValue > 0 && (
                        <h5 className="mb-0">{item.cardValue}</h5>
                      )}
                      <p className="m-0 text-info">
                        {item.cardValue ? <></> : item.alt}
                      </p>
                    </div>

                    <div className="avatar-sm ms-auto">
                      <div className="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i className={"bx bxs-" + `${item.iconClass}`}></i>
                      </div>
                    </div>
                  </div>
                </Link>
              </CardBody>
            </Card>
          </Col>
        ))} */}
        <Col sm="12" md="12" lg="8">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="id"
                columns={columns}
                data={studentVarisangyaWalletsData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col md="4">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <form
                              className="app-search d-lg-block"
                              onChange={e =>
                                debounceStudentVarisangyaWalletSearch(
                                  e.target.value
                                )
                              }
                            >
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search..."
                                  defaultValue={searchText}
                                />
                                <span className="bx bx-search-alt" />
                              </div>
                            </form>
                          </div>
                        </div>
                      </Col>
                      <div className="col-md-8">
                        <Link
                          to={`/student/varisangya/transaction/create?instituteId=${instituteId}`}
                          style={{ width: "120px" }}
                          className="w-md btn btn-success m-auto me-0 d-block"
                        >
                          {language === "mal" ? "+ എൻട്രി " : "+ Entry"}
                        </Link>
                      </div>
                    </Row>
                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                selectRow={selectRow}
                                classes={"table align-middle table-wrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                              />
                            </div>
                          </Col>
                        </Row>
                        <MyPagination
                          totalPages={pages}
                          page={page}
                          setPage={setPage}
                        />
                      </>
                    )}
                    {studentVarisangyaWallets &&
                      studentVarisangyaWallets?.results?.length <= 0 && (
                        <p
                          style={{ fontSize: "15px" }}
                          className="text-center text-info"
                        >
                          {language === "mal"
                            ? "വരിസംഖ്യകൾ ഒന്നും ഇല്ല"
                            : "No Varisangyas Yet"}
                        </p>
                      )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default AllStudentVarisangyaTransactions

AllStudentVarisangyaTransactions.propTypes = {
  history: PropTypes.object,
}
